import { Loader2 } from 'lucide-react';

import {
  CATEGORY_ICONS,
  DEFAULT_CATEGORY_ICON,
} from '../../constants/redaction';
import type {
  RedactionCategory,
  RedactionCategoryInfo,
} from '../../types/redaction';

export default function CategoryStep({
  available,
  loading,
  categories,
  onToggle,
  termsInput,
  onTermsChange,
}: {
  available: RedactionCategoryInfo[];
  loading: boolean;
  categories: RedactionCategory[];
  onToggle: (value: RedactionCategory) => void;
  termsInput: string;
  onTermsChange: (value: string) => void;
}) {
  return (
    <div className="mx-auto w-full max-w-3xl px-6 py-8">
      <h3 className="text-sm font-bold uppercase tracking-wider text-gray-500">
        What should be considered for withholding?
      </h3>
      {loading && (
        <div className="mt-3 flex items-center gap-2 text-sm text-gray-400">
          <Loader2 className="h-4 w-4 animate-spin" />
          Loading categories...
        </div>
      )}
      <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2">
        {available.map((category) => {
          const Icon = CATEGORY_ICONS[category.value] ?? DEFAULT_CATEGORY_ICON;
          const checked = categories.includes(category.value);
          return (
            <label
              key={category.value}
              className={`flex cursor-pointer items-start gap-3 rounded-xl border p-3 transition ${
                checked
                  ? 'border-emerald-300 bg-emerald-50'
                  : 'border-gray-200 bg-white hover:bg-gray-50'
              }`}
            >
              <input
                type="checkbox"
                checked={checked}
                onChange={() => onToggle(category.value)}
                className="mt-0.5 h-4 w-4 rounded border-gray-300 text-emerald-600 focus:ring-emerald-500"
              />
              <span className="flex-1">
                <span className="flex items-center gap-1.5 text-sm font-semibold text-gray-900">
                  <Icon className="h-4 w-4 text-gray-400" />
                  {category.label}
                </span>
                <span className="mt-0.5 block text-xs text-gray-500">
                  {category.description}
                </span>
              </span>
            </label>
          );
        })}
      </div>

      <h3 className="mt-6 text-sm font-bold uppercase tracking-wider text-gray-500">
        Your own terms
      </h3>
      <p className="mt-1 text-xs text-gray-500">
        One per line. Use this for anything specific to this document that
        automatic detection would not know to look for.
      </p>
      <textarea
        value={termsInput}
        onChange={(event) => onTermsChange(event.target.value)}
        rows={4}
        placeholder={'Neighbour at number 14\nThe blue shed'}
        className="mt-2 w-full rounded-xl border border-gray-200 px-3 py-2 text-sm focus:border-emerald-500 focus:outline-none focus:ring-1 focus:ring-emerald-500"
      />
    </div>
  );
}
